import { useState } from 'react'

const useNestedSelection = () => {
  const [selections, setSelections] = useState({})

  const updateSelection = (identifier, index) => {
    const clone = { ...selections }
    const groupHasSelection = selections[identifier] !== undefined

    if (!groupHasSelection) {
      setSelections({
        ...clone,
        [identifier]: [index],
      })

      return
    }

    const selection = clone[identifier]

    if (selection.includes(index)) {
      clone[identifier] = clone[identifier].filter((record) => record !== index)
    } else {
      clone[identifier] = [ ...selection, index ]
    }

    setSelections(clone)
  }

  const updateMultipleSelections = (identifier, indexes) => {
    const groupHasSelection = selections[identifier] !== undefined

    if (!groupHasSelection) {
      setSelections({
        ...selections,
        [identifier]: indexes,
      })
    } else {
      setSelections({
        ...selections,
        [identifier]: undefined,
      })
    }
  }

  const updateAllSelections = (selections) => {
    setSelections(selections)
  }

  return [selections, updateSelection, updateMultipleSelections, updateAllSelections]
}

export default useNestedSelection
